import axios from 'axios';
import {API_ROOT} from '../constants/urls';

const requests = {
  get: url => axios.get(`${API_ROOT}${url}`),
  post: (url, body) => axios.post(`${API_ROOT}${url}`, body),
};

const dtoService = {
  getDto: (subdomain, objectType, objectId, token) => requests.get(`/Share/GetDto?subdomain=${subdomain}&objectType=${objectType}&objectId=${objectId}&token=${token}`),
  getPhotos: (subdomain, objectType, objectId, token, inspectionId) => requests.get(`/Share/GetPhotos?subdomain=${subdomain}&objectType=${objectType}&objectId=${objectId}&token=${token}&inspectionId=${inspectionId || ''}`),
};

export default {
  dtoService,
};
